import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function ViewSectionQuestion() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-2570">
      <div className="flex items-center justify-between" data-id="element-2571">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2572">Section Question</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/questions')} data-id="element-2573">
          ← Back to Questions
        </Button>
      </div>

      <Card data-id="element-2574">
        <CardContent className="pt-6" data-id="element-2575">
          <table className="text-sm w-full" data-id="element-2576">
            <tbody data-id="element-2577">
              <tr className="border-b border-slate-100" data-id="element-2578">
                <td className="py-2 pr-6 font-medium text-slate-700 w-32 align-top" data-id="element-2579">
                  Id
                </td>
                <td className="py-2 text-slate-900" data-id="element-2580">101</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2581">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2582">
                  Course
                </td>
                <td className="py-2 text-slate-900" data-id="element-2583">Desert Ecology Basics</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2584">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2585">
                  Section
                </td>
                <td className="py-2 text-slate-900" data-id="element-2586">Section 1</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2587">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2588">
                  Question
                </td>
                <td className="py-2 text-slate-900 leading-relaxed" data-id="element-2589">
                  What is the primary water source for desert flora?
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2590">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2591">Answer</td>
                <td className="py-2 text-slate-900 capitalize" data-id="element-2592">yes</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2593">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2594">
                  Created
                </td>
                <td className="py-2 text-slate-900" data-id="element-2595">2023-01-15</td>
              </tr>
              <tr data-id="element-2596">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2597">
                  Modified
                </td>
                <td className="py-2 text-slate-900" data-id="element-2598">2023-06-20</td>
              </tr>
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>;
}